module.exports = __webpack_public_path__ + "static/laura-cros-KtJy7cZV5OQ-unsplash-a4b9f3219bfd182e226e00a805785ae6.png";